var React = require('react');

function ArrowRight200 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M1.88477 14.3119L201.885 14.3119","stroke":"#454553","strokeWidth":"3","strokeMiterlimit":"10","strokeLinecap":"round","key":0}),React.createElement("path",{"d":"M188.885 2L201.517 14.3046","stroke":"#454553","strokeWidth":"3","strokeMiterlimit":"10","strokeLinecap":"round","key":1}),React.createElement("path",{"d":"M188.885 26.6238L201.517 14.3046","stroke":"#454553","strokeWidth":"3","strokeMiterlimit":"10","strokeLinecap":"round","key":2})]);
}

ArrowRight200.defaultProps = {"width":"204","height":"29","viewBox":"0 0 204 29","fill":"none"};

module.exports = ArrowRight200;

ArrowRight200.default = ArrowRight200;
